import { RadioButton, RadioButtonInputGroup } from '@sb1/ffe-form-react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormActions } from '../../../utils/form-helpers';
import filtersFormConfig from '../filters-form-config';
import styles from './giver-data-type-radios.module.less';

const GIVERDATA_TYPE = 'giverData';
const TAXREFUND_TYPE = 'taxRefund';
const ALL = 'all';
const COLLECTORS = 'collectors';

const { setFormField } = getFormActions(filtersFormConfig);

export const GiverDataTypeRadios = () => {
    const dispatch = useDispatch();
    const { dataType } = useSelector((state) => state.filtersForm);

    const dataTypes = [
        { label: 'Giverdata', property: GIVERDATA_TYPE },
        { label: 'Skattefradrag', property: TAXREFUND_TYPE },
        { label: 'Alle transaksjoner', property: ALL },
        { label: 'Innsamlere', property: COLLECTORS },
    ];

    const onChange = (e) => {
        dispatch(setFormField('dataType', e.target.value));
    };

    return (
        <RadioButtonInputGroup
            label={'Hva vil du hente?'}
            name={'radio'}
            selectedValue={dataType ?? dataTypes?.[0]?.property}
            onChange={onChange}
            className={styles.radio}
        >
            {(inputProps) =>
                dataTypes.map((d) => (
                    <RadioButton {...inputProps} key={d.property} value={d.property}>
                        {d.label}
                    </RadioButton>
                ))
            }
        </RadioButtonInputGroup>
    );
};
